import React from 'react';

export const ICShareExtension: React.FC = () => {
    return (
        <svg
            width="20"
            height="20"
            fill="#4f4b5c"
            viewBox="0 0 800 800"
            xmlSpace="preserve"
        >
            <path
                fill="#4f4b5c"
                fillRule="evenodd"
                d="M33.332 616.96c0-178.03 130.059-324.593 300-355.429v-77.824c0-62.41 71.781-97.52 121.043-59.203L732.473 340.8c38.605 30.027 38.605 88.37 0 118.402L454.379 675.496c-49.266 38.317-121.047 3.211-121.047-59.203v-65.664c-75.297 14.453-134.582 53.226-169.074 105.496-19.852 30.086-54.07 36.324-78.938 29.324-25.164-7.078-51.984-31.097-51.988-68.488zM413.445 177.13c-5.472-4.258-13.449-.356-13.449 6.578v130.184c0 4.601-3.754 8.32-8.351 8.445-121.946 3.277-225.72 78.047-269.457 183.184a288.91 288.91 0 00-15.528 49.382 290.832 290.832 0 00-6.64 58.832c-.012 1.075-.02 2.149-.02 3.227 0 4.496 6.14 6.2 8.617 2.445a241.87 241.87 0 011.633-2.445c10.898-16.149 23.438-31.078 37.414-44.695 9.5-9.25 19.66-17.891 30.43-25.891 57.199-42.516 131.453-66.965 213.558-68.52 4.606-.085 8.348 3.657 8.348 8.258v130.18c0 6.937 7.977 10.836 13.45 6.582l278.093-216.297c4.289-3.336 4.289-9.816 0-13.156zm0 0"
            ></path>
        </svg>
    );
};
